import { Preferences } from '@capacitor/preferences';
import {
  decryptJson,
  decryptString,
  encryptJson,
  encryptString,
  isEncryptedPayload,
} from './crypto';

async function readString(key: string): Promise<string | null> {
  const { value } = await Preferences.get({ key });
  if (value == null) return null;
  try {
    const plain = decryptString(value);
    if (!plain && isEncryptedPayload(value)) {
      await Preferences.remove({ key });
      return null;
    }
    return plain || null;
  } catch {
    if (isEncryptedPayload(value)) await Preferences.remove({ key });
    return null;
  }
}

export const Storage = {
  async getString(key: string): Promise<string | null> {
    return readString(key);
  },

  async setString(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value: encryptString(value) });
  },

  async getJson<T>(key: string): Promise<T | null> {
    const { value } = await Preferences.get({ key });
    if (value == null) return null;
    const parsed = decryptJson<T>(value);
    if (parsed == null && isEncryptedPayload(value)) {
      await Preferences.remove({ key });
    }
    return parsed;
  },

  async setJson<T>(key: string, value: T): Promise<void> {
    await Preferences.set({ key, value: encryptJson(value) });
  },

  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  },

  async clearAll(): Promise<void> {
    await Preferences.clear();
    if (typeof window !== 'undefined') {
      try {
        window.localStorage.clear();
      } catch {
        /* ignore */
      }
      try {
        window.sessionStorage.clear();
      } catch {
        /* ignore */
      }
    }
  },
};
